{
  "alert": "Alertă",
  "dismiss": "Revocare"
}
